import { render } from "./ConfigGroup.vue?vue&type=template&id=1b58f022&scoped=true&ts=true"
import script from "./ConfigGroup.vue?vue&type=script&lang=ts"
export * from "./ConfigGroup.vue?vue&type=script&lang=ts"

import "./ConfigGroup.vue?vue&type=style&index=0&id=1b58f022&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b58f022"]])

export default __exports__